/**
 * This constant is used to indicated the name of the tracking event.
 */
export const TrackingEvents = {
    loadTheFinancialProducts: 'PAGGeneric_FinanceCalculator_Load',
    changeFinancialProducts: 'PAGGeneric_FinanceCalculatorFinancialProduct_Click',
    changeMonthDuration: 'PAGGeneric_FinanceCalculatorFinancingDuration_Click',
    increaseDownPaymentPercentage: 'PAGGeneric_FinanceCalculatorIncreaseDownpayment_Click',
    decreaseDownPaymentPercentage: 'PAGGeneric_FinanceCalculatorDecreaseDownpayment_Click',
    openModalToOut: 'PAGGeneric_FinanceCalculatorConfirmFinancingOffer_Click',
    gotoPreApprovalApp: 'PAGGeneric_FinanceCalculatorRequestFinancingOffer_Click'
};
